<section id="steps-to-a-safer-pet" class="steps position-relative py-5 overflow-hidden">

  <div class="container position-relative z-1">

    <h2 class="steps__title display-3 text-center mb-4 mb-lg-5">Three steps to a safer pet</h2>

    <div class="steps__grid">

      <div class="steps__image-area">
        <div class="steps__image-wrapper w-100 h-100">
          <img src="/assets/images/home/man-with-dog.webp" srcset="/assets/images/home/man-with-dog-430.webp 430w, /assets/images/home/man-with-dog.webp 550w" sizes="430px" width="550" height="826" alt="Person with pet" class="steps__image w-100 h-100 object-fit-cover">
        </div>
      </div>

      <app-home-step-card-v2
        class="steps__card steps__card--1"
        [number]="1"
        title="Register your microchip"
        body="Link your pet's microchip to your contact details, so they can always be traced back to you."
        badgePosition="left">
      </app-home-step-card-v2>
 
      <app-home-step-card-v2
        class="steps__card steps__card--2"
        [number]="2"
        title="Select your protection plan"
        body="Choose the cover that feels right for you and your pet, with options designed to suit every need."
        badgePosition="right">
      </app-home-step-card-v2>
 
      <app-home-step-card-v2
        class="steps__card steps__card--3"
        [number]="3"
        title="Update your details"
        body="Keep your details up to date, so you can always be contacted if your pet ever goes missing."
        badgePosition="left">
      </app-home-step-card-v2>

    </div>

    <div class="d-flex flex-column flex-sm-row justify-content-center gap-3 mt-4 mt-lg-5">
      <a routerLink="/choose-plan" class="btn ui-btn ui-btn--primary fw-bold">Our plans</a>
    </div>

  </div>

  <app-background-icon
    src="/assets/images/icons/treats.svg"
    [top]="12"
    [left]="18"
    [width]="150"
    [opacity]="0.5"
  />
  <app-background-icon
    src="/assets/images/icons/cat.svg"
    [top]="10"
    [left]="90"
    [width]="190"
    [opacity]="0.5"
  />
  <app-background-icon
    src="/assets/images/icons/kennel.svg"
    [top]="60"
    [left]="5"
    [width]="170"
    [opacity]="0.5"
  />
  <app-background-icon
    src="/assets/images/icons/carry_crate.svg"
    [top]="40"
    [left]="80"
    [width]="170"
    [opacity]="0.5"
  />
  <app-background-icon
    src="/assets/images/icons/medicine.svg"
    [top]="90"
    [left]="8"
    [width]="150"
    [opacity]="0.5"
  />
  <app-background-icon
    src="/assets/images/icons/paw.svg"
    [top]="75"
    [left]="80"
    [width]="150"
    [opacity]="0.5"
  />

</section>
